export default __webpack_public_path__ + "static/media/frontsight.54d62bb6.png";